

const modals = document.querySelectorAll(".modal");
const iframes = document.querySelectorAll("iframe");
const modalBackdrop = document.querySelector(".modal-backdrop");
const modalCloseBtns = document.querySelectorAll(".modal-close");
const modalTriggers = document.querySelectorAll(".modal-trigger");
const body = document.getElementsByTagName('body');

const openModal = (e) => {
	e.preventDefault();

	let target = e.target.closest('a').dataset.target;
	
  
  if ( target === 'modal-video') {
    let vid_src = e.currentTarget.getAttribute('href');
  	let modal = document.getElementById('modal-video');
    
  
    modal.classList.add('open');
  
    let videotype = e.target.closest('a').dataset.videotype;

    if ( videotype === 'hubspot'){

      let video = document.querySelector('#modal-video video');
      video.src = vid_src;
      video.play();
    }
    
    if ( videotype === 'youtube'){
      let iframe = document.querySelector('#modal-video iframe');
      iframe.src = vid_src;
    }

    modalBackdrop.classList.add('open');
    document.body.style.overflowY = 'hidden'
  }
  if ( target === 'modal-bio') {
    document.body.style.overflowY = 'hidden'

  	let modal = e.currentTarget.getAttribute('href');
    let id = document.getElementById(modal)
    id.showModal();

  }


}

const closeModal = () => {

  let modals = document.querySelectorAll('.modal');
  let dialogs = document.querySelectorAll('dialog');
  
  if ( document.querySelector('#modal-video iframe') ){
    let iframe = document.querySelector('#modal-video iframe');
    iframe.src = ''
  }
  if ( document.querySelector('#modal-video video') ){
    let video = document.querySelector('#modal-video video');
    video.src = ''
  }


  modals.forEach( m => m.classList.remove('open') )
  dialogs.forEach( d => d.close() )

	modalBackdrop.classList.remove('open');
  document.body.style.overflowY = ''
}

document.addEventListener("keyup", (e) => {if (e.key === "Escape") closeModal()});

modalTriggers.forEach(btn => btn.addEventListener('click', openModal));
modalCloseBtns.forEach(btn => btn.addEventListener('click', closeModal));
modalBackdrop.addEventListener('click', closeModal);


if ( document.querySelector('#modal-video img') ){
  document.querySelector('#modal-video img').addEventListener('click', function() {
    this.className = 'active';
  });
}
